import React, { useState } from 'react'
import AllBuyer from '../AllBuyer/AllBuyer';
import Allseller from '../AllSeller/Allseller';

export default function ServiceOwnerDetails() {
  
  const [activeTab, setActiveTab] = useState('allbuyer');

  return (
       <div className=' shadow-custom rounded-xl py-5'>
                      {/* Tabs */}
                      <div className='flex items-center gap-5 mt-10'>
                          <h1
                              onClick={() => setActiveTab('allbuyer')}
                              className={`text-xl px-5 font-bold cursor-pointer 
                                  ${activeTab === 'allbuyer' ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}
                              `}
                          >
                              All Buyer
                          </h1>
                          <h1
                              onClick={() => setActiveTab('allseller')}
                              className={`text-xl px-5 font-bold cursor-pointer 
                                  ${activeTab === 'allseller' ? 'text-[#FF0000]  underline decoration-[#FF0000]  underline-offset-4' : 'text-gray-500 hover:text-[#FF0000] '}
                              `}
                          >
                             All Seller
                          </h1>
                      </div>
                      {/* Content with Transition */}
                      <div className="relative">
                          <div
                              className={`transition-opacity duration-300 ease-in-out transform ${
                                  activeTab === 'allbuyer' ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10 absolute'
                              }`}
                          >
                              <AllBuyer/>
                          </div>
                          <div
                              className={`transition-opacity duration-300 ease-in-out transform ${
                                  activeTab === 'allseller' ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10 absolute'
                              }`}
                          >
                              <Allseller/>
                          </div>
                      </div>
                      </div>
  )
}
